

// export default LeftSidebar;
import React from "react";
import { CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom"; // nextjs'de useRouter

const features = [
  "10 Yıllık Tecrübe",
  "%100 Garanti",
  "Adresten Alım Teslim",
  "2-3 Gün İçinde Teslim",
  "Yerinde Koltuk Yıkama",
  "Organik Deterjan Kullanımı",
  "Yorgan ve Battaniye Temizliği",
  "Ücretsiz Servis Hizmeti",
  "Tüm Halı Türlerine Uygun Yıkama",
  "Halı Tamiri ve Overlok",
  "Kısa Sürede Kuruma",
  "Hijyenik Tam Otomatik Yıkama",
  "Perde Yıkama Hizmeti",
  "Antibakteriyel Ürün Kullanımı",
  "Yerinde Profesyonel Hizmet",
  "Koşulsuz Müşteri Memnuniyeti"
];

const categoryVisuals = {
  "Halı Yıkama": "/images/cat1.png",
  "Koltuk Yıkama": "/images/cat2.png",
  "Videolar": "/images/cat3.png",
};

const slugify = (str) => str.toLowerCase().replace(/\s+/g, "-");

const LeftSidebar = () => {
  const navigate = useNavigate(); // Next.js kullanıyorsan useRouter().push()

  const handleOpen = (cat) => {
    const slug = slugify(cat); // örnek: "Halı Yıkama" → "hali-yikama"
    navigate(`/galeri/${slug}`);
  };

  return (
    <aside className="space-y-6">
      <div className="bg-black border border-gray-200 rounded-xl shadow p-4 w-full">
        <h3 className="text-lg font-semibold text-[#222fe9e3]">
          Neden Bizi Tercih Etmelisiniz?
        </h3>
        <ul className="space-y-2.5 text-sm text-white">
          {features.map((item, i) => (
            <li key={i} className="flex items-start gap-3">
              <CheckCircle size={20} className="text-green-500 mt-1" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Kategori Kutuları */}
      <div className="flex flex-col items-center gap-4">
        {Object.keys(categoryVisuals).map((cat, index) => (
          <div
            key={index}
            onClick={() => handleOpen(cat)}
            className="relative w-85 sm:w-65 md:w-70 shadow-md rounded-xl overflow-hidden cursor-pointer transition hover:scale-105"
          >
            <img
              src={categoryVisuals[cat]}
              alt={cat}
              className="w-full h-auto object-contain"
            />
            <div className="absolute inset-0 bg-white bg-opacity-10 flex items-center justify-center">
              <span className="text-lg font-bold text-gray-800">{cat}</span>
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default LeftSidebar;
